<template>
  <nav
    class="comp-container comp-container__nav PT-m PR-s PB-m PL-s BGC-white"
  >
    <template v-if="$route.params.brandId">
      <div
        class="logo"
        v-on:click="goBrand()"
        v-if="logo"
      >
        <img :src="logo">
      </div>
      <div
        class="back P-xxs C-grey"
        v-on:click="handleClickBack()"
        v-else-if="prev"
      >
        <span class="material-icons-round">arrow_back</span>
      </div>
    </template>
    <template v-if="$route.params.brandId && !disableUser">
      <div
        class="user C-grey"
        v-on:click="$emit('select-user')"
      >
        <div class="avatar POS-r W-xl H-xl">
          <template v-if="user.logged_in">
            <img class="W-xl H-xl BDRS-100" :src="user.avatar" v-if="user.avatar">
            <img class="W-xl H-xl BDRS-100" src="@/assets/default-avatar.svg" v-else>
          </template>
          <template v-else>
            <span class="material-icons-round avatar-icon M-xxs">person</span>
            <div class="not-vip POS-a BGC-notice BDRS-100"></div>
          </template>
        </div>
        <span class="material-icons-round">expand_more</span>
      </div>
    </template>
  </nav>
</template>

<script>

import { mapState } from 'vuex';

export default {
  components: {
  },
  props: {
    prev: {
      type: Function,
      required: false,
    },
    logo: {
      type: String,
      required: false,
    },
    isVIP: {
      type: Boolean,
      default: false,
    },
    disableUser: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState([
      'user',
    ]),
  },
  methods: {
    handleClickBack() {
      if (this.prev) {
        this.prev();
      }
    },
    goBrand() {
      this.$router.push({ name: 'Brand', params: { brandId: this.$route.params.brandId } });
    },
  },
};

</script>

<style lang="sass" scoped>
.comp-container__nav
  top: 0
  position: sticky
  z-index: $z-index-fixed
  display: flex
  align-items: center

  transition: transform $time-fast $cb

  &.is-mini
    @extend .PT-s
    @extend .PB-s
    transform: translateY(-8px)

    .logo,
    .back,
    .powered-by,
    .user
      transform: scale(.75)
    .i18n-picker
      display: none

  .logo,
  .back,
  .powered-by,
  .user
    flex-grow: 1
    transition: transform $time-fast $cb

  .logo,
  .back,
  .user
    height: 32px
    width: 56px

  .logo,
  .back
    transform-origin: left bottom

    cursor: pointer

  .logo
    img
      @extend .W-xl
      @extend .H-xl

      @extend .BDRS-100

  .powered-by
    transform-origin: center bottom

  .user
    display: flex
    justify-content: flex-end
    align-items: center

    transform-origin: right bottom

    cursor: pointer

    span
      width: 24px
      height: 24px

    .vip
      right: -4px
      bottom: -4px
      padding: 2px 4px

      border: 3px solid white

      font-size: 12px

      transform: scale(.5)
      transform-origin: right bottom

    .not-vip
      right: 2px
      bottom: 2px
      width: 10px
      height: 10px

      border: 2px solid white
</style>
